// Shared LMS types (ported from CreatINN, adapted to LSEM + Supabase)

export interface LmsLesson {
  id: string;
  module_id: string;
  title: string;
  content: string;
  video_url: string | null;
  duration: string;
  position: number;
  is_free: boolean;
  resources: string;
}

export interface LmsModule {
  id: string;
  course_id: string;
  title: string;
  description: string;
  position: number;
  lessons: LmsLesson[];
}

export interface LmsCourse {
  id: string;
  slug: string;
  title: string;
  description: string;
  tagline: string;
  thumbnail: string | null;
  price_value: number;
  duration: string;
  level: string;
  category: string;
  is_published: boolean;
  is_featured?: boolean;
  created_at?: string;
  modules: LmsModule[];
}

export interface LessonProgress {
  lesson_id: string;
  completed: boolean;
}

/** Convert a YouTube / bare URL into an embeddable https URL (ported from CreatINN normalizeVideoUrl). */
export function normalizeVideoUrl(url?: string | null): string | null {
  if (!url) return null;
  const s = String(url).trim();
  if (!s) return null;
  if (/^https?:\/\//i.test(s)) return s;
  const ytIdMatch = s.match(/(?:v=|youtu\.be\/|embed\/)([A-Za-z0-9_-]{6,})/);
  if (ytIdMatch?.[1]) return `https://www.youtube.com/watch?v=${ytIdMatch[1]}`;
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return `https://www.youtube.com/watch?v=${s}`;
  if (/^[^\s]+\.[^\s]+/.test(s)) return `https://${s}`;
  return s;
}

export function toEmbedUrl(url: string | null): string | null {
  const n = normalizeVideoUrl(url);
  if (!n) return null;
  // YouTube watch -> embed
  const yt = n.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  if (yt?.[1]) return `https://www.youtube.com/embed/${yt[1]}`;
  return n;
}
